<template>
    <div class="conf">
      <el-form label-width="20%">
        <el-form-item v-for="item in dataList" :label="`${item.name}配置:`" label-width="100px" :key="item.prop">
            <div>
                <span>按公式修改：</span>
                  <span v-if="item.hasExchangeRate">&nbsp;(&nbsp;</span>
                  <el-select v-model="item.formData.formulaValue.priceMultiplier" width="130px">
                      <!-- <el-option :label="item.name +  item.name" value="now"></el-option> -->
                      <el-option v-for="c in item.priceList" :label="c.label" :value="c.value" :key="c.value"></el-option>
                  </el-select>
                  X
                  <el-input-digit v-model.number="item.formData.formulaValue.percentage" :precision="0" :max="999" nullable style="width: 80px">
                    <span>%</span>
                  </el-input-digit>
                  +
                  <el-input-digit v-model.number="item.formData.formulaValue.addValue" :precision="2" nullable style="width: 80px">
                    <span>元</span>
                  </el-input-digit>
                  -
                  <el-input-digit v-model.number="item.formData.formulaValue.subtractionValue" :precision="2" nullable style="width: 80px">
                    <span>元</span>
                  </el-input-digit>
                  <span v-if="item.hasExchangeRate">&nbsp;)&nbsp;<span style="margin:0 5px;">X</span></span>
                  <div style="display:inline-block;line-height:2;" v-if="item.hasExchangeRate">
                    <InputDigitComb 
                      v-model="item.formData.exchangeRate" 
                      placeholder="汇率"
                      :format="false" :precision="10"
                      :readonly="true"
                      @click="()=>openSetExchangeRate(item.prop)"
                    >
                        <el-select v-model="item.formData.currencyUnit" slot="append" placeholder="请选择" width="70px" disabled>
                          <el-option v-for="c in config.currencyList" :value="c.code" :label="c.code" :key="c.code"></el-option>
                      </el-select>
                    </InputDigitComb>
                  </div>
            </div>
        </el-form-item>
      </el-form>
      <div class="top-tips">注意：建议零售价、申报价公式仅在新增商品资料时生效；商品铺货价格统一以平台商品资料为准</div>
      <el-dialog
        title="汇率设置"
        v-if="['pddtemu','pddtemu_btg'].includes(platform)"
        :visible.sync="exchangeRateVisible"
        width="350px"
      >
        <div class="flex align-center">
           <div class="mr-5">1CNY&nbsp;&nbsp;=&nbsp;&nbsp;</div>
           <InputDigitComb v-model="exchangeRate.rate" style="height:30px;" :format="false" :precision="10" placeholder="汇率">
              <el-select v-model="exchangeRate.currencyType" slot="append" placeholder="请选择" width="70px">
                  <el-option v-for="c in config.currencyList" :value="c.code" :label="c.code" :key="c.code"></el-option>
              </el-select>
            </InputDigitComb>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="exchangeRateVisible = false">取 消</el-button>
          <el-button type="primary" @click="exchangeRateConfirm">确 定</el-button>
        </span>
      </el-dialog>
    </div>
</template>

<script>
import { mapGetters } from "vuex"
import { cloneDeep,merge } from 'lodash'
import InputDigitComb from '@/components/prod/center/components/FormItemSpecification/components/InputDigitComb.vue'
const defaultExchangeRate = {
    key:'',
    rate:'',
    currencyType:'USD'
}
const getPriceConfig = (obj={}) => {
  let defaultData = {
    formulaValue:{
      priceMultiplier:'base_sales',
      formula:'',
      percentage:100,
      addValue:0,
      subtractionValue:0,
      centDime:''
    },
    exchangeRate:'',
    currencyUnit:'USD'
  }
  return merge(defaultData,obj)
}
export default {
  props: {
    platform:{
      type:String,
      default:''
    },
    config:{
      type:Object,
      default:()=> {}
    },
    commonPrice:{
      type:Object,
      default: () => {}
    },
  },
  components:{
    InputDigitComb
  },
  data() {
    return {
      dataList:[],
      exchangeRateVisible:false,
      exchangeRate:{...defaultExchangeRate}
    };
  },
  watch: {
    commonPrice: {
      handler(v) {
        this.initData()
      },
      immediate:true
    },
  },
  computed: {
    ...mapGetters(['isDistributor']),
  },
  methods: {
    initData(){
      let list = [];
      this.config.configList.forEach(cfg => {
        let newObj = {}
        if(!cfg.hasExchangeRate){
          newObj.currencyUnit = ''
        }
        let defaultPriceConfig = getPriceConfig(newObj);
        let priceConfig = this.commonPrice[cfg.prop] || {}
        let obj = {
          ...cfg,
          formData:merge(defaultPriceConfig,priceConfig),
        }
        list.push(obj)
      });
      this.$set(this,'dataList',list)
    },
    getData() {
      let obj = {}
      this.dataList.forEach(item => {
        obj[item.prop] = {
          ...item.formData
        }
      });
      let isVerify = true
      if(!obj.retailPriceConf?.exchangeRate){ // 汇率必填校验
        isVerify = false
      }
      return isVerify ? obj : false
    },
    openSetExchangeRate(prop){
      let item = this.dataList.find(i => i.prop === prop)
      let newExchangeRate = {...defaultExchangeRate,key:prop}
      if(item){
        newExchangeRate.rate = item.formData.exchangeRate ? item.formData.exchangeRate : newExchangeRate.rate
        newExchangeRate.currencyType = item.formData.currencyUnit
      }
      this.$set(this,'exchangeRate',newExchangeRate)
      this.exchangeRateVisible = true
    },
    exchangeRateConfirm(){
      const {key,rate,currencyType} = this.exchangeRate;
      let item = this.dataList.find(i => i.prop === key)
      if(item){
        this.$set(item.formData,'exchangeRate',rate)
        this.$set(item.formData,'currencyUnit',currencyType)
        this.exchangeRateVisible = false
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.top-tips{
  color: #ff3333;
  margin-bottom: 10px !important;
  padding-left: 45px;
}
</style>